// Footer-Link „Reklamation“ (das Formular selbst ist wie das Kontaktformular nur auf Deutsch).
const de = { complaintLink: "Reklamation" };
const en = { complaintLink: "Complaints" };
const tr = { complaintLink: "Şikayet" };
const pl = { complaintLink: "Reklamacja" };
const uk = { complaintLink: "Скарга" };
const all = { de, en, tr, pl, uk };
export default all;
